import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PageLoader from "components/PageLoader";

const LazyNotification = lazy(() => import('pages/Notification'));

function NotificationRoute() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<LazyNotification />} />
      </Routes>
    </Suspense>
  );
}

export default NotificationRoute;
